































import { Vue, Prop, Component } from "vue-property-decorator"

@Component({})
export default class CreateRecipeProcedure extends Vue {
	@Prop({ required: true }) recipe!: RecipeObject;

	deleteStep(index: number) {
		this.$root.$emit("delete-step", index)
	}

	addStep() {
		this.$root.$emit("add-step")
	}
}
